export class IPeriod {
  titleDE: string;
  titleEN: string;
  month: number;
  year: number;
  date: Date;
  value: string;
  periodStart: Date;
  periodEnd: Date;
}
